import { gql, useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { NOTIFICATION_TYPE, showNotification } from '@thinknet-gmbh/platform-common-ui';
import { GET_APPLICATION_BY_ID } from './get-application-by-id.hook';
import { GET_EAU_APPLICATIONS } from './get-applications.hook';

export const DELETE_EAU_APPLICATION_BY_ID = gql`
  mutation deleteEauApplication($id: String!) {
    deleteEauApplication(id: $id) {
      _id
    }
  }
`;

export const useDeleteEauApplication = ({ onSuccess }: { onSuccess: () => void }) => {
  const { t } = useTranslation('applications');
  const [deleteEauApplication] = useMutation(DELETE_EAU_APPLICATION_BY_ID, {
    onCompleted: data => {
      onSuccess();
      if (data?.deleteEauApplication?._id) {
        showNotification({
          isIcon: false,
          type: NOTIFICATION_TYPE.success,
          message: t('eAU.notifications.deletedSuccessfully'),
        });
      }
    },
    onError: ({ graphQLErrors = [] }: { graphQLErrors?: any }) => {
      const [error] = graphQLErrors || [];

      return showNotification({
        isIcon: false,
        type: NOTIFICATION_TYPE.error,
        message: t('userProfileSettings.error.title'),
        description: error,
      });
    },
    refetchQueries: [GET_APPLICATION_BY_ID, GET_EAU_APPLICATIONS],
  });

  return deleteEauApplication;
};
